module.exports = __webpack_public_path__ + "img/lea-26.5427feda.png";